<template>
  <div class="pv">
    <div class="pv__scan-box">
      <span class="pv__scan-icon">🛍️</span>
      <div v-if="run && step < dims.length" class="pv__scan-line"></div>
      <div v-if="step >= dims.length - 1" class="pv__scan-ok">✅</div>
    </div>
    <div class="pv__grid">
      <div
        v-for="(d, i) in dims"
        :key="d"
        class="pv__dim"
        :class="{ 'pv__dim--on': i <= step }"
      >
        <span>{{ i <= step ? '✅' : '⏳' }}</span>
        <span class="pv__dim-name" :class="{ 'pv__dim-name--on': i <= step }">{{ d }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevDetect',
  props: { run: { type: Boolean, default: false } },
  data() {
    return { step: -1, timer: null, dims: ['图片合规', '标题合规', 'SKU合规', 'AI鉴图'] }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.step = -1; return }
      let i = -1
      this.timer = setInterval(() => {
        i++
        this.step = i
        if (i >= this.dims.length - 1) clearInterval(this.timer)
      }, 550)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__scan-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, .05);
  border: 1px solid rgba(255, 255, 255, .1);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
.pv__scan-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00C8F5, transparent);
  animation: gx-scanLine .8s linear infinite;
}
.pv__scan-ok {
  position: absolute;
  inset: 0;
  background: rgba(76, 175, 122, .15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  animation: gx-checkPop .4s ease-out both;
}
.pv__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 5px; }
.pv__dim {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 7px;
  background: rgba(255, 255, 255, .03);
  border: 1px solid rgba(255, 255, 255, .07);
  transition: all .3s;
  font-size: 10px;
}
.pv__dim--on { background: rgba(76, 175, 122, .08); border-color: rgba(76, 175, 122, .3); }
.pv__dim-name { color: rgba(240, 230, 210, .35); transition: color .3s; }
.pv__dim-name--on { color: rgba(240, 230, 210, .85); }
</style>
